const $doc = $(document);

$doc.on('click', '.js-accordion .js-accordion-head', function() {
  const $this = $(this);


  if ($this.closest('.js-accordion').hasClass('js-accordion--siblings')) {
    $this
      .siblings('.js-accordion-body')
      .slideToggle(400)
      .closest('.js-accordion-section')
      .toggleClass('expanded')
      .siblings()
      .removeClass('expanded')
      .find('.js-accordion-body')
      .slideUp();
  } else {
    $this
      .siblings('.js-accordion-body')
      .slideToggle(400)
      .closest('.js-accordion-section')
      .toggleClass('expanded');
  }
})



// WEBPACK FOOTER //
// ../assets/js/accordion.js